import React from 'react';
import { Heading } from '../../common/form/form-parts';
import CheckBadgeIcon from '@tradera/blueprint/theme/icons2/check-badge.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import { FormFooterLogo } from 'tradera/apps/registration/components/common/form/form-footer-logo';

export const SwedishPrivateFormAccountCreated = (props) => {
    const {
        successfulSubmissionData: { emailAddress, redirectLink },
        helpUrl,
        isNativeAppContext
    } = props;

    return (
        <>
            <div />
            <div className={'mt-7'}>
                <div className={'text-center'}>
                    <CheckBadgeIcon className="icon icon-xxl" />
                </div>
                <Heading>Tack! Vänligen kolla din e-post</Heading>
                <div className={'mb-3'}>
                    Du får inom kort ditt lösenord skickat till din e-postadress
                    (<strong>{emailAddress}</strong>).
                </div>
                <div className={'mb-3'}>
                    Inte fått något lösenord? Beroende på dina
                    e-postinställningar kan mejlet hamnat i skräppostmappen. I
                    vissa fall kan det ta upp till 24h innan kontot är godkänt
                    på grund av verifiering av dina uppgifter.
                </div>

                <Button
                    theme="primary"
                    fluid
                    className="my-3"
                    href={
                        isNativeAppContext ? 'tradera://login' : redirectLink
                    }>
                    {isNativeAppContext ? 'Fortsätt' : 'Klar'}
                </Button>
                <div className={'text-center mb-3'}>
                    Har du problem? <a href={helpUrl}>Kontakta oss</a>
                </div>
            </div>
            <div className="text-center mb-4">
                <FormFooterLogo />
            </div>
        </>
    );
};
